import { render } from "./HowitWorks.vue?vue&type=template&id=3975b3a2"
import script from "./HowitWorks.vue?vue&type=script&lang=js"
export * from "./HowitWorks.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__